// src/components/billing/ChargeSummary.jsx — what «Passa ora» charges today, as a small table (v204).
//
// `rows` = `[{ id, label, value }]` from billing/confirmContent.js (our labels on billing/money.js rows: the new
// plan's price, the unused part of the current plan, VAT, the total — or subtotal / VAT / total). ⛔ Figures are
// printed as given, never computed here. Rendered as BillingConfirmDialog's `children`, above the buttons.
import React from 'react';
import { COLORS, FONT_SANS, RADII } from '../../constants/theme.js';

const TABLE = {
  width: '100%', borderCollapse: 'collapse', margin: '4px 0 14px', fontFamily: FONT_SANS, fontSize: '13px',
  color: COLORS.ink, background: COLORS.field, borderRadius: RADII.controlInner,
};
const CELL = { padding: '6px 12px', fontWeight: 400 };
const TOTAL = { ...CELL, fontWeight: 700, borderTop: `1px solid ${COLORS.borderStrong}` };

export default function ChargeSummary({ rows }) {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  return (
    <table style={TABLE}>
      <tbody>
        {rows.map((row) => {
          const style = row.id === 'total' ? TOTAL : CELL;
          return (
            <tr key={row.id}>
              <th scope="row" style={{ ...style, textAlign: 'left' }}>{row.label}</th>
              <td style={{ ...style, textAlign: 'right', whiteSpace: 'nowrap' }}>{row.value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
